module.exports = __webpack_public_path__ + "static/media/innoedu2.32b28de1.png";